import React, { useEffect } from "react";

import normalBrBlack from "../../assets/logo/logo-brcomerce.png"
import { getFestiveLogo } from "../../utils/getFestiveLogo";

export default function LogoImage({ className, logo, variant, style }) {
  const [logoImg, setLogoImg] = React.useState(normalBrBlack);

  useEffect(() => {
    setLogoImg(getFestiveLogo(logo, variant))
  }, [logo, variant])

  return (
    <img src={logoImg} className={className} alt="Logo Brcomerce" style={style} />
  )
}
